import React, { useState, useRef, useEffect } from "react";
import { TextField } from "@mui/material";

const VerificationInput = ({ onInputFilled }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (otp.join("").length === 6) {
      onInputFilled(otp.join(""));
    }
  }, [otp, onInputFilled]);

  const handleInputChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text");
    if (/^\d{6}$/.test(pasteData)) {
      const newOtp = pasteData.split("");
      setOtp(newOtp);
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div
      className="d-flex justify-content-between gap-2"
      style={{ flexWrap: "nowrap", overflowX: "auto" }}
    >
      {otp.map((value, index) => (
        <TextField
          key={index}
          inputRef={(el) => (inputRefs.current[index] = el)}
          variant="outlined"
          margin="dense"
          value={value}
          placeholder="-"
          onChange={(e) => handleInputChange(index, e.target.value)}
          onPaste={handlePaste}
          onKeyDown={(e) => handleKeyPress(e, index)}
          sx={{
            width: "60px",
            height: "60px",
            borderRadius: "10px",
            "& .MuiOutlinedInput-notchedOutline": {
              top: -7,
            },
            "& .MuiOutlinedInput-root": {
              height: "100%",
              borderRadius: "10px",
              fontSize: "22px",
              textAlign: "center",
              padding: 0,
              backgroundColor: "white",
              "& input": {
                textAlign: "center",
                padding: 0,
              },
            },
          }}
          css-1ll44ll-MuiOutlinedInput-notchedOutline
          inputProps={{
            maxLength: 1,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
        />
      ))}
    </div>
  );
};

export default VerificationInput;
